import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, ChevronRight, Download, AlertTriangle, Users, FileText } from 'lucide-react';

export default function HeroSection() {
  return (
    <section 
      className="hero-section relative"
      style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1760970237216-17a474403b5c?w=1920&q=80)'
      }}
      data-testid="hero-section"
    >
      <div className="hero-overlay" />
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-24 text-white">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 mb-8">
            <ShieldCheck size={16} className="text-rose-400" />
            <span className="text-xs font-bold uppercase tracking-wider">
              Marco normativo actualizado (Marzo 2026)
            </span>
          </div>

          {/* Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-none animate-fade-in">
            Reincorporaciones tras baja larga: los 7 errores que más dinero cuestan
          </h1>

          {/* Subheadline */}
          <p className="mt-6 text-xl text-slate-200 max-w-2xl">
            Evite sanciones de hasta <span className="font-bold text-rose-400">983.736 €</span> y despidos nulos. 
            El Tribunal Supremo ya no perdona los informes genéricos.
          </p>

          {/* CTAs */}
          <div className="mt-10 flex flex-wrap gap-4">
            <Link 
              to="/protocolo" 
              className="btn btn-accent text-base"
              data-testid="hero-cta-protocolo"
            >
              Iniciar autodiagnóstico legal
              <ChevronRight size={18} />
            </Link>
            <a 
              href="#recursos" 
              className="btn btn-secondary text-base"
              data-testid="hero-cta-resources"
            >
              <Download size={18} />
              Descargar eBook gratuito
            </a>
          </div>

          {/* Stats */}
          <div className="mt-16 grid sm:grid-cols-3 gap-6">
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-6">
              <AlertTriangle className="text-rose-400 mb-3" size={24} />
              <p className="text-3xl font-bold">983.736 €</p>
              <p className="text-sm text-slate-400 mt-1">Sanción máxima LISOS</p>
            </div>
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-6">
              <Users className="text-amber-400 mb-3" size={24} />
              <p className="text-3xl font-bold">&lt;25</p>
              <p className="text-sm text-slate-400 mt-1">Trabajadores = PYME sensible</p>
            </div>
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-6">
              <FileText className="text-emerald-400 mb-3" size={24} />
              <p className="text-3xl font-bold">Ley 2/2025</p>
              <p className="text-sm text-slate-400 mt-1">Nueva normativa vigente</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom gradient fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-slate-50 to-transparent" />
    </section>
  );
}
